/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

//phoenix imports
import { ButtonViewType } from '@airasia-phoenix/react-native/components/ButtonView';
import { LabelType } from '@airasia-phoenix/react-native/components/LabelView/types';
import { Dimensions } from 'react-native';

const Constants = {
  FLIGHT_HOTEL_PROMOTION_LABEL_TYPE: LabelType.FILLED_RED,
  SEARCH_FLIGHTS_BUTTON_TYPE: ButtonViewType.PRIMARY_REGULAR,
  SCROLL_SPEED: 0.9,
  IMAGE_HEIGHT: 150,
  get IMAGE_WIDTH() {
    const screenWidth = Dimensions.get('window').width;
    return screenWidth;
  },
};

export default Constants;
